<template>
  <div :class="getClassName('add-cart')">
    <div :class="getClassName('add-cart__summary')">価格</div>
    <!-- アイアンレール、ロングエプロンでは表示しない -->
    <div :class="getClassName('add-cart__text')" v-if="item.category.id != 13 && item.category.id != 2">
      ギフトラッピングは注文画面でお選びいただけます。
    </div>
    <div :class="getClassName('add-cart__total')" v-if="getTotalPrice">
      合計：
      <span :class="getClassName('add-cart__st')">{{ getTotalPrice }}</span>
      <span :class="getClassName('add-cart__unit')">円</span>
      （税込）
    </div>
    <div :class="getClassName('add-cart__total')" v-else>購入内容に不備があります。</div>

    <button
      :class="getClassName('add-cart__button')"
      type="button"
      @click="addCart"
      :disabled="isFetching"
      v-if="enableCart"
    >
      <IconCart :class="getClassName('add-cart__icon')" />カートに入れる
    </button>
    <div :class="getClassName('add-cart__message')" v-else>
      現在のカートにこの商品は追加できません。<br />先に購入手続きをお済ませ下さい。
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { APP_URL, API_URL } from '../../../config/const';
import { OK, CREATED, UNPROCESSABLE_ENTITY, ERROR_MESSAGES, numberFormat } from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

import IconCart from '../images/IconCart';

const ENABLE_GA = process.env.MIX_ENABLE_GA === 'true';

export default {
  mixins: [getClassName],
  components: {
    IconCart,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    form: {
      type: Object,
      required: true,
      default: () => {},
    },
    enableCart: {
      type: Boolean,
      required: true,
      default: true,
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
    noPartsFlg: {
      type: Boolean,
      required: true,
      default: false,
    },
    noPartsVueFlg: {
      type: Boolean,
      required: true,
      default: false,
    },
    isIronCurtainRail: {
      type: Boolean,
      required: true,
      default: false,
    },
    noApprovalIronCurtainRailFlg: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isFetching: false,
    };
  },
  computed: {
    getTotalPrice() {
      const setectedOption = this.getOption;

      const partsItems = this.item.parts_categories.flatMap((category) => category.items);
      const partsPrice = this.form.parts.reduce((prev, form) => {
        const [item] = partsItems.filter((item) => item.id === form.item_id);
        const [option] = item.options.filter((option) => option.id === form.item_option_id);
        return prev + option.price * form.quantity;
      }, 0);

      return setectedOption ? numberFormat(setectedOption.price * this.form.quantity + partsPrice) : 0;
    },
    getColor() {
      const [color] = this.item.colors.filter((color) => color.id === parseInt(this.form.item_color_id));
      return color;
    },
    getSize() {
      const [size] = this.item.sizes.filter((size) => size.id === parseInt(this.form.item_size_id));
      return size;
    },
    getOption() {
      const [option] = this.item.options.filter((option) => option.id === parseInt(this.form.item_option_id));
      return option;
    },
    getPartsItems() {
      const parts = this.item.parts_categories.flatMap((category) => category.items);
      return this.form.parts.map((form) => {
        const [item] = parts.filter((item) => item.id === form.item_id);
        const [color] = item.colors.filter((option) => option.id === form.item_color_id);
        const [size] = item.sizes.filter((option) => option.id === form.item_size_id);
        const [option] = item.options.filter((option) => option.id === form.item_option_id);
        return {
          ...item,
          color: { ...color },
          size: { ...size },
          option: { ...option },
          quantity: form.quantity,
        };
      });
    },
  },
  methods: {
    async addCart() {
      if(this.noPartsVueFlg){
        if(this.form.parts.length === 0 && this.noPartsFlg === false){
          const errorText1 = '❹パーツをお選びください。';
          const errorText2 = '※パーツが不要な場合は「パーツなし」をお選びください。';
          this.$emit('alert', {
            varient: 'error',
            messages: [errorText1, errorText2],
          });
          return false;
        }
      }

      if(this.isIronCurtainRail === true && this.noApprovalIronCurtainRailFlg === false){
        // アイアンレール 承認チェック
        const errorText1 = '※チェック項目に不備があります。';
        const errorText2 = '内容をご確認のうえ、ご承認ください。';
        this.$emit('alert', {
          varient: 'error',
          messages: [errorText1, errorText2],
        });
        return false;
      }

      //   if (!confirm('この商品をカートに追加します。\nよろしいですか？')) return;
      await this.switchFetching(true);
      const response = await axios.post(API_URL + '/cart', this.form);

      if (response.status === OK) {
        this.sendTransaction();

        location.href = APP_URL + '/cart';
        await this.switchFetching(false);
        return false;
      }

      if (response.status === UNPROCESSABLE_ENTITY) {
        this.$emit('alert', {
          varient: 'error',
          messages: Object.keys(response.data.errors).flatMap((key) => response.data.errors[key]),
        });
        await this.switchFetching(false);
        return false;
      }

      this.$emit('alert', {
        varient: 'error',
        messages: [ERROR_MESSAGES[response.status]],
      });

      await this.switchFetching(false);
    },
    switchFetching(bool) {
      this.isFetching = bool;
    },
    sendTransaction() {
      if (!ENABLE_GA) return;

      gtag('event', 'add_to_cart', {
        items: [
          {
            item_id: this.getOption.jan_code,
            item_name: `${this.item.category.name} ${this.item.name}（カラー：${this.getColor.name}、サイズ：${this.getSize.name}）`,
            item_category: this.item.category.name,
            item_variant: `カラー：${this.getColor.name}、サイズ：${this.getSize.name}`,
            index: 1,
            quantity: this.form.quantity,
            price: this.getOption.price,
          },
          ...this.getPartsItems.map((item) => ({
            item_id: item.option.jan_code,
            item_name: `${item.category.name} ${item.name}（カラー：${item.color.name}、サイズ：${item.size.name}）`,
            item_category: item.category.name,
            item_variant: `カラー：${item.color.name}、サイズ：${item.size.name}`,
            index: 1,
            quantity: item.quantity,
            price: item.option.price,
          })),
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';

.add-cart {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-end;
  position: relative;
  &--sp {
    align-items: center;
  }
  &__summary {
    color: $color__title;
    font-size: 1.3rem;
    line-height: 1;
    letter-spacing: 1em;
    align-self: flex-start;
    &--sp {
      background: $color__cell;
      width: 100%;
      padding: 8px 0;
      border-bottom: solid 1px $color__line--item;
      font-size: 0.8rem;
      text-align: center;
      letter-spacing: 0.03em;
      align-self: center;
    }
  }
  &__text {
    align-self: flex-start;
    position: absolute;
    top: 42px;
    left: 24px;
    &::before {
      content: '※';
    }
    &--sp {
      margin-top: 10px;
      align-self: center;
      position: static;
    }
  }
  &__total {
    margin-top: -3px;
    color: $color__active;
    font-size: 1.4rem;
    line-height: 1;
    display: flex;
    align-items: baseline;
    &--sp {
      margin-top: 10px;
      font-size: 1.1rem;
    }
  }
  &__st {
    font-size: 2.6rem;
    &--sp {
      font-size: 2rem;
    }
  }
  &__unit {
    font-size: 1.8rem;
    &--sp {
      font-size: 1.4rem;
    }
  }
  &__button {
    background: $color__active;
    width: 375px;
    height: 48px;
    border-radius: 24px;
    margin-top: 30px;
    color: #fff;
    font-size: 1.5rem;
    letter-spacing: 0.1em;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &--sp {
      width: calc(100% - 26.667px);
      height: 30px;
      border-radius: 15px;
      margin-top: 10px;
      font-size: 1.1rem;
    }
  }
  &__icon {
    width: 20px;
    height: auto;
    margin-right: 3px;
    &--sp {
      width: 15px;
      margin-right: 7px;
    }
  }
  &__message {
    margin-top: 15px;
    text-align: right;
  }
}
</style>
